/* global translations, zxcvbn */
var Sp = Sp || {};

(function (app) {
	'use strict';

	var isSubmitting = false;

	if (!String.prototype.trim) {
		String.prototype.trim = function () {
			return this.replace(/^\s+|\s+$/g, '');
		};
	}

	var addValidationErrorClass = function (el) {
		el.classList.add('s-validation-error');
	};

	var removeValidationErrorClass = function (el) {
		el.classList.remove('s-validation-error');
	};

	app.validateEmailAddress = function (el) {
		var emailReg = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;

		var res = emailReg.test(el.value);
		if (res === false) {
			addValidationErrorClass(el.parentNode);
		} else {
			removeValidationErrorClass(el.parentNode);
		}

		return res;
	};

	app.validate = function (el, minlength) {
		var res = true;
		var type = 'text';
		if (el.hasAttribute('data-ps-validation-type')) {
			type = el.getAttribute('data-ps-validation-type');
		}

		if ((el.hasAttribute('data-val-required') || el.hasAttribute('required')) && !el.value) {
			addValidationErrorClass(el.parentNode);
			res = false;
		} else if (minlength && el.value && el.value.length < minlength) {
			addValidationErrorClass(el.parentNode);
			res = false;
		} else if (el.hasAttribute('data-val-required') || el.hasAttribute('required')) {
			removeValidationErrorClass(el.parentNode);
		}

		if (type === 'email') {
			res = app.validateEmailAddress(el);
		}

		for (var i = 0; i < el.children.length; i++) {
			if (!app.validate(el.children[i])) {
				res = false;
			}
		}

		return res;
	};

	app.adjustEntropyBar = function (el) {
		if (!el) {
			throw new Error('Element can not be NULL');
		}
		var entropy = zxcvbn(el.value, app.getCommonPasswords()).entropy;

		var $indicatorBar = $('.indicator-bar');

		if (entropy <= 30) {
			$indicatorBar.css({
				'width': entropy * 2 + '%',
				'background-color': 'rgb(238, 17, 51)'
			});
			$('.indicator-text').text(translations && translations.password_strength_tooweak || 'Strength: Too weak');
			$('#icon-password').css('visibility', 'hidden');
		} else if (entropy > 30 && entropy <= 40) {
			$indicatorBar.css({
				'width': entropy * 2 + '%',
				'background-color': 'rgb(255, 136, 0)'
			});
			$('.indicator-text').text(translations && translations.password_strength_ok || 'Strength: Ok');
			$('#icon-password').css('visibility', 'visible');
		} else {
			$indicatorBar.css({
				'width': entropy > 50 ? 100 + '%' : entropy * 2 + '%',
				'background-color': 'rgb(173, 196, 12)'
			});
			$('.indicator-text').text(translations && translations.password_strength_strong || 'Strength: Strong');
			$('#icon-password').css('visibility', 'visible');
		}
	};

	app.findPos = function (el) {
		var curleft = 0,
			curtop = 0;

		if (el.offsetParent) {
			curleft = el.offsetLeft;
			curtop = el.offsetTop;

			while (el.offsetParent !== null) {
				el = el.offsetParent;

				curleft += el.offsetLeft;
				curtop += el.offsetTop;
			}
		}

		return [curleft, curtop];
	};

	app.clearValidation = function (form) {
		var elements = form.getElementsByClassName('s-validation-error');

		for (var i = 0; i < elements.length; i++) {
			elements[i].classList.toggle('s-validation-error');
		}
	};

	app.login = function (form) {
		app.clearValidation(form);

		if (app.validate(form) && !isSubmitting) {
			isSubmitting = true;
			form.submit();
		}

		return false;
	};

	app.setup = function (form) {
		app.clearValidation(form);

		var formValidated = app.validate(form);
		var passwordsValidated = app.passwordsMatchAndNotEmpty();
		if (!passwordsValidated) {
			addValidationErrorClass(document.getElementById('password').parentNode);
			addValidationErrorClass(document.getElementById('confirmedpassword').parentNode);
		}
		else if (formValidated && !isSubmitting) {
			isSubmitting = true;
			form.submit();
		}

		return false;
	};

	app.setPasswordClicked = function () {
		var $firstPassword = document.getElementById('password'),
			$secondPassword = document.getElementById('confirmedpassword'),
			$error = document.getElementsByClassName('error')[0],
			result = $firstPassword.value === $secondPassword.value;

		if (!$error) {
			var content = document.getElementsByClassName('content')[0];
			$error = document.createElement('div');
			$error.className += ' error';

			content.insertBefore($error, content.firstChild);
		}

		if (!result) {
			$error.innerHTML = translations && translations.passwords_match_error || 'The typed passwords does not match';
			result = false;
		}

		if ($firstPassword.value.trim() === '' || $secondPassword.value.trim() === '') {
			$error.innerHTML = translations && translations.password_is_required || 'Password is required';
			result = false;
		}

		if (result === true) {
			var entropy = zxcvbn($firstPassword.value).entropy;
			if (entropy < 30) {
				result = false;
				$error.innerHTML = translations && translations.password_strength_notaccepted || 'The password strength is too weak.';
			}
		}

		if (result === false) {
			$firstPassword.parentNode.classList.add('s-validation-error');
			$secondPassword.parentNode.classList.add('s-validation-error');
			$error.style.display = '';
		} else {
			$firstPassword.parentNode.classList.remove('s-validation-error');
			$secondPassword.parentNode.classList.remove('s-validation-error');
			$error.style.display = 'none';
		}

		return result;
	};

	app.passwordsMatchAndNotEmpty = function () {
		var $firstPassword = document.getElementById('password'),
			$secondPassword = document.getElementById('confirmedpassword'),
			result = $firstPassword.value === $secondPassword.value;

		if ($firstPassword.value.trim() === '' || $secondPassword.value.trim() === '') {
			result = false;
		}

		if (result === false) {
			$('#icon-password-confirm').css('visibility', 'hidden');
		} else {
			$('#icon-password-confirm').css('visibility', 'visible');
		}

		return result;
	};

	app.isCapslock = function (e) {
		var charCode = e.keyCode || e.which || e.charCode || 0,
			s = String.fromCharCode(charCode);

		return s.toUpperCase() === s && s.toLowerCase() !== s && !e.shiftKey && !e.altKey;
	};

	app.hideTooltip = function (el) {
		if (el.tooltip) {
			el.parentNode.removeChild(el.tooltip);
			el.tooltip = null;
		}
	};

	app.showTooltip = function (el, content) {
		var elPosition = app.findPos(el);

		el.tooltip = document.createElement('div');

		el.tooltip.className += ' tool-tip';
		el.tooltip.innerHTML = content;
		el.tooltip.style.left = elPosition[0] + 'px';
		el.tooltip.style.top = elPosition[1] + 45 + 'px';

		el.parentNode.insertBefore(el.tooltip, el.nextSibling);
	};

	app.checkCapsLock = function (e) {
		e = e || event;

		var myTarget = e.target,
			el;

		var elements = document.getElementsByClassName('error');

		for (var i = 0; i < elements.length; i++) {
			elements[i].style.display = 'none';
		}

		if (myTarget && myTarget.parentNode) {
			el = myTarget.parentNode;

			app.hideTooltip(el);

			if (app.isCapslock(e)) {
				var warningMessageHeader = translations && translations.capsLock_warning_header || 'Caps Lock is On',
					warningMessageBody = translations && translations.capsLock_warning_body || 'Having Caps Lock on may cause you to enter your password incorrectly.';

				app.showTooltip(el, '<div><div class="arrow-border"></div>' +
					'<div class="arrow"></div>' +
					'<div class="bold">' + warningMessageHeader + '</div>' +
					'<div>' + warningMessageBody + '</div>' +
					'</div>');
			}
		}
	};

	app.expand = function (el) {
		var elements = el.getElementsByClassName('content');

		for (var i = 0; i < elements.length; i++) {
			elements[i].style.display = 'block';
		}
	};

	app.insertReturnUrl = function () {
		var hash = window.location.hash,
			hiddenReturlUrl = document.getElementsByName('ReturnUrl');

		if (hiddenReturlUrl.length > 0 && hash !== null && hash !== '') {
			for (var i = 0; i < hiddenReturlUrl.length; i++) {
				hiddenReturlUrl[i].value += hash;
			}
		}
	};

	app.readCookie = function (name) {
		name += '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i].trim();
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}

		return '';
	};

	app.setCookie = function (name, value, expirationDays) {
		var d = new Date();
		d.setTime(d.getTime() + expirationDays * 24 * 60 * 60 * 1000);
		var expires = 'expires=' + d.toUTCString();
		document.cookie = name + '=' + value + '; ' + expires;
	};

	app.setRememberMe = function (element) {
		var existingValue = app.readCookie('.PSRememberMe');
		if (existingValue) {
			element.checked = existingValue === 'true';
		}
	};

	app.rememberMeChanged = function (el) {
		app.setCookie('.PSRememberMe', el.checked, 365);
	};

	$(function () {
		$('.textbox').focusin(function () {
			$(this).addClass('s-focus');
		});
		$('.textbox').focusout(function () {
			$(this).removeClass('s-focus');
		});
	});
}(Sp));